import {
  GET_BASED_COST_URL,
  UPDATE_BASED_COST_URL,
  FINANCE_STATS_URL,
  FINANCE_REPORTING_URL,
} from 'consts/api';
import { bodyGetBasedCost } from 'consts/filters';
import services from './index';
import querystring from 'query-string';

class FinanceServices {
  getBasedCost(body = bodyGetBasedCost) {
    return services.post(GET_BASED_COST_URL, body);
  }

  updateBasedCost(
    body = {
      country: '',
      price: '',
      service: '',
      vendor: '',
    }
  ) {
    return services.post(UPDATE_BASED_COST_URL, body);
  }

  getFinanceStats(
    body = {
      from: '2024-08-03-00',
      to: '2024-08-04-23',
      route: '',
      sortBy: 'BYCLIENT',
      direction: 'DESC',
      timezone: 'Etc/GMT',
      includedNonRouteStats: false,
      includeUsernames: [],
      excludeUsernames: [],
      showAccountTotal: true,
    },
    configs
  ) {
    return services.post(FINANCE_STATS_URL, body, configs);
  }

  getFinanceReport(
    body = {
      sourceFrom: '',
      sourceTo: '',
      from: '',
      to: '',
      type: '',
    }
  ) {
    return services.post(`${FINANCE_REPORTING_URL}/getComparableStats`, body);
  }

  getFinanceSummaryStats(
    body = {
      sourceFrom: '',
      sourceTo: '',
      from: '',
      to: '',
      timezone: '',
    }
  ) {
    return services.post(`${FINANCE_REPORTING_URL}/getFinanceSummaryStats`, body);
  }

  exportCSV(
    body = {
      sourceFrom: '',
      sourceTo: '',
      from: '',
      to: '',
      timezone: '',
    }
  ) {
    return services.post(`${FINANCE_REPORTING_URL}/exportCSV`, body);
  }

  getWalletHistory(body = { from: '', to: '', username: '' }) {
    return services.post(`${FINANCE_REPORTING_URL}/general/wallet-history`, body);
  }

  getCreditTransactionHistory(body = { from: '', to: '', username: '', type: '' }) {
    return services.post(`${FINANCE_REPORTING_URL}/general/credit-transaction-history`, body);
  }

  getFinanceSummaryStatsV2(
    body = {
      sourceFrom: '2024-07-01-00',
      sourceTo: '2024-07-01-23',
      from: '2024-07-04-00',
      to: '2024-07-04-23',
      type: 'vertical',
      timezone: 'Etc/GMT',
    },
    configs
  ) {
    return services.post(`${FINANCE_REPORTING_URL}/getFinanceSummaryStatsV2`, body, configs);
  }

  getPeriodFinanceStats(
    body = {
      unit: 'week',
      from: '01-2024',
      to: '05-2024',
      timezone: 'Etc/GMT',
    },
    configs
  ) {
    return services.post(`${FINANCE_REPORTING_URL}/getPeriodFinanceStats`, body, configs);
  }

  saveCorrectStats(
    body = {
      id: null,
      key: 'DID_MAINTAIN_oanhhhtest@gmail.com:Plivo - Valtteri:Route support RVM:us:null:0.001:0.002',
      serviceType: 'DID_MAINTAIN',
      correctionCost: 0.01,
      correctionPrice: 0.02,
      description: 'H test',
      datetime: 24080310,
      amount: 80,
    }
  ) {
    return services.post(`${FINANCE_REPORTING_URL}/general/saveCorrectStats`, body);
  }

  updateFinanceLayout(
    body = {
      financeLayouts: [
        'AUDIO_BUILDER_ASSISTANT',
        'DID_MAINTAIN',
        'CONTACT_DATA_STORAGE',
        'OUTBOUND_VB_CALL',
      ],
    }
  ) {
    return services.post(`${FINANCE_REPORTING_URL}/general/updateFinanceLayout`, body);
  }

  searchHistoryCorrectStats(
    body = {
      key: '',
      from: '24092014',
      to: '24092105',
      pageNumber: 1,
      pageSize: 2,
    },
    configs
  ) {
    return services.get(
      `${FINANCE_REPORTING_URL}/general/search-history?${querystring.stringify(body)}`,
      configs
    );
  }
}

export default new FinanceServices();
